<template>
  <!-- 只有在 is_show 为 true 时才渲染整个容器 -->
  <div v-if="is_show && is_show_2" style="align-items: flex-start;" class="container">
    <div class="biao_list">
      <div @click="handle_biao_(item)" v-for="item, index in biao_di_list" :key="index"
        :class="cli_item == item.ID ? 'select_' : ''" class="biao_item">
        <el-image v-if="item.IMAGE_ARR[0]" :src="item.IMAGE_ARR[0]" style="width: 120px; height: 120px"
          :fit="'cover'"></el-image>

        <img v-else style="width:  120px; height:  120px" src="../assets/null_image.png" alt="">

        <span class="title_text">
          {{ item.TITLE }}
        </span>

      </div>
    </div>
    <div style="flex: 1;width: 1100px;">

      <div class="bdw_detail">
        <div class="bdw_text">
          <div style="display: flex;align-items: flex-start;flex-direction: column;" class="text_2">
            <div style="margin-bottom: 5px;">
              {{ formatDate(detail_data.BIDDING_START_TIME_TXT) }}开始
            </div>
            <!-- <span style="margin: 0 10px;"> | </span> -->
            <div v-if="detail_data.STATUS < 3 || djs_.seconds != 'end'" style="margin-top: 0" class="b">
              <!-- 倒计时显示 -->
              <span style="color: #333"> 竞价/询比价倒计时: </span>
              <!-- 倒计时结束或未开始的提示 -->

              <!-- 正在倒计时 -->
              <span>
                <span style="color: #999; margin: 0 3px">距离开始:</span>
                <span style="color: #c31424;font-weight: 600;" class="time">{{ djs_.days }}</span>
                <span style="color: #c31424;font-weight: 600;" class="text">天</span>
                <span style="color: #c31424;font-weight: 600;" class="time">{{ djs_.hours }}</span>
                <span style="color: #c31424;font-weight: 600;" class="text">时</span>
                <span style="color: #c31424;font-weight: 600;" class="time">{{ djs_.minutes }}</span>
                <span style="color: #c31424;font-weight: 600;" class="text">分</span>
                <span style="color: #c31424;font-weight: 600;" class="time">{{ djs_.seconds }}</span>
                <span style="color: #c31424;font-weight: 600;" class="text">秒</span>
              </span>
            </div>
            <div class="status_9">
              <div class="daijingjia">
                {{ text_fun }}
              </div>
              <div class="jjfs">
                <div v-if="detail_data.BIDDING.BIDDING_TYPE == 2" class="jjfs_item">
                  竞价方式：多轮竞价
                </div>
                <div v-if="detail_data.BIDDING.BIDDING_TYPE == 1" class="jjfs_item">
                  竞价方式：单轮竞价
                </div>

                <div class="jjfs_item">
                  项目分类：{{ detail_data.TYPE_NAME }}
                </div>
                <div v-if="detail_data.BIDDING.BIDDING_TYPE == 2" class="jjfs_item">
                  竞价方式：多轮竞价
                </div>
                <div v-show="detail_data.IS_NEED == '1'" class="jjfs_item">
                  保证金：{{ detail_data.NEED_MONEY.MONEY }}元
                </div>
                <div v-show="detail_data.BIDDING?.DURATION" class="jjfs_item">
                  自由竞价时长：{{ detail_data.BIDDING?.DURATION }}分钟
                </div>
                <div v-show="detail_data.BIDDING?.ROUND_DELAY" class="jjfs_item">
                  延时周期时长：{{ detail_data.BIDDING?.ROUND_DELAY }}分钟
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="boxlist">
        <!-- 循环行：显示每个标的物的信息 -->
        <div>

          <div style="min-height: 228px" class="item_box">
            <!-- <div v-for="(item, index) in biao_di_list" :key="index" style="min-height: 228px" class="item_box"> -->
            <!-- 标的物图片轮播 -->
            <div class="swiper">
              <!-- <el-carousel v-if="biaodi_item.IMAGE_ARR.length != 0" height="285px"> -->
              <el-carousel height="285px">
                <el-carousel-item v-for="(i, index1) in biaodi_item.IMAGE_ARR" :key="index1">
                  <el-image :preview-src-list="biaodi_item.IMAGE_ARR" style="width: 285px; height: 285px" :src="i"
                    :fit="'cover'"></el-image>

                </el-carousel-item>
              </el-carousel>
            </div>
            <!-- 标的物右侧信息 -->
            <div class="right_box">
              <div class="title">
                <div class="l">
                  <div class="t">
                    <div class="c">
                      <!-- 标的物标题和说明按钮 -->
                      <div style="display: flex; align-items: center; color: #000; margin-bottom: 5px">
                        {{ biaodi_item.TITLE }}
                        <!-- 点击查看标的物说明 -->
                        <div @click="handle_info(biaodi_item.OBJ_DESC)" class="info_box">标的物说明 <i
                            class="el-icon-warning-outline"></i></div>
                      </div>

                      <div v-if="biaodi_item.STARTING_PRICE != 0" class="price_item">

                        <span>
                          起拍价:
                        </span>

                        <span style="color: #c31424;font-weight: 600;">
                          ￥ {{ biaodi_item.STARTING_PRICE }}
                        </span>

                      </div>

                      <!-- 价格信息 (根据 PRICE_TERMS 判断显示方式) -->
                      <div v-if="detail_data.BIDDING.PRICE_TERMS == 1" class="i">
                        <!-- 1: 明标 -->
                        <!-- 起拍价 -->
                        <!-- <span v-if="item.STARTING_PRICE != 0" style="color: #999999">起拍价: </span>
                    <span style="color: #c31424" v-if="item.STARTING_PRICE != 0"> {{ item.STARTING_PRICE }}元</span> -->
                        <!-- 当前最高报价 -->
                        <span v-if="biaodi_item.MAX_MSG && detail_data.BIDDING.BIDDING_TYPE == 2"
                          style="color: #999999; margin-left: 0px">当前最高报价: </span>
                        <span style="color: #c31424"
                          v-if="biaodi_item.MAX_MSG && detail_data.BIDDING.BIDDING_TYPE == 2">
                          {{
                            biaodi_item.MAX_MSG || '-' }}元</span>
                        <!-- 我的报价 -->
                        <span v-if="biaodi_item.MAIN_MSG"
                          style="color: #999999;margin-top: 5px;margin-left: 10px;">我的报价:
                        </span>
                        <span style="color: #c31424" v-if="biaodi_item.MAIN_MSG"> {{ biaodi_item.MAIN_MSG || '-'
                        }}元</span>
                      </div>
                      <!-- PRICE_TERMS != 1 可能为暗标或其他，模板中未明确处理 -->
                    </div>
                  </div>

                  <!-- 报价区域 (仅在竞价中状态 STATUS == 4 显示) -->
                  <!-- <div @click="handle_index(index)" style="width: 300px" class="b"> -->
                  <div class="b">
                    <!-- <div @click="handle_index(index)" class="b"> -->
                    <div>

                      <div style="display: flex; align-items: center">
                        <div style="color: #000; font-size: 20px; width: 90px; margin-right: 5px;width: 90px;">出价:
                        </div>
                        <!-- 明标报价输入框 -->

                        <div v-if="detail_data.BIDDING.PRICE_TERMS == 1" class="i">
                          <!-- 1: 明标 -->
                          <!-- 起拍价 -->
                          <!-- <span v-if="item.STARTING_PRICE != 0" style="color: #999999">起拍价: </span> -->
                          <!-- <span style="color: #c31424" v-if="item.STARTING_PRICE != 0"> {{ item.STARTING_PRICE }}元</span> -->
                        </div>

                        <el-input v-if="detail_data.BIDDING.PRICE_TERMS == 1" v-model="biaodi_item.bj"
                          placeholder="请输入">
                          <span v-if="detail_data.BIDDING.PRICE_TERMS == 1"
                            style="display: flex;align-items: center;height: 40px;color: #000;" slot="suffix"> {{
                              biaodi_item.RANGE_TYPE == 1 ? '元' : '%' }}</span>
                        </el-input>
                        <!-- 非明标报价 (可能是文件上传) -->
                        <div v-else>
                          <div class="file_name">
                            {{ file_name }}
                            <!-- 显示已上传的文件名 -->
                          </div>
                          <!-- 文件上传组件 -->
                          <my-upload :limit="5" :auto-upload="true" up_load="/api/user/upload"
                            @success="handleUploadSuccess3" @error="handleUploadError" />
                        </div>
                      </div>
                      <div class="jiajia">
                        <el-button @click="handle_jiajia(biaodi_item, item_)"
                          v-for="item_, index_ in biaodi_item.RANGE_VALUE_ARR" :key="index_" class="item_jiajia"
                          type="primary">+{{ item_ }}</el-button>
                      </div>

                      <div class="baojia_">
                        <div style="">
                          提示： {{ biaodi_item.OPERATOR == 1 ? '出价需≥最高报价＋加价幅度' : '出价需 ≤最低报价-减价幅度' }}
                        </div>
                        <div style="color: #333;display: flex;justify-content: space-between;">
                          <span> {{ biaodi_item.QUOTED_TEXT }}</span> <span>报价次数:{{ biaodi_item.QUOTED_COUNT
                          }}次</span>
                        </div>
                        <div style="margin-top: 5px;">
                          <!-- 立即报价按钮 -->
                          <!-- 多轮竞价 或 一口价且未报价时 -->
                          <div
                            v-if="detail_data.BIDDING.BIDDING_TYPE == 2 && detail_data.STATUS == 4 && biaodi_item.OBJ_STATUS != 1"
                            class="ljbj">
                            <el-button @click="handle_chujia(biaodi_item)" style="width: 100%"
                              type="primary">立即报价</el-button>
                          </div>
                          <div
                            v-if="detail_data.BIDDING.BIDDING_TYPE == 1 && biaodi_item.IS_BAOJIA == false && detail_data.STATUS == 4 && biaodi_item.OBJ_STATUS != 1"
                            class="ljbj">
                            <el-button @click="handle_chujia(biaodi_item)" style="width: 100%"
                              type="primary">立即报价</el-button>
                          </div>
                          <!-- 一口价且已报价时 (按钮置灰) -->
                          <div
                            v-if="detail_data.BIDDING.BIDDING_TYPE == 1 && biaodi_item.IS_BAOJIA == true || detail_data.STATUS != 4"
                            class="ljbj">
                            <!-- <el-button @click="handle_re_baojia(item)" style="width: 100%" type="info">立即报价</el-button> -->
                            <el-button @click="handle_re_baojia()" style="width: 100%" type="info">立即报价</el-button>
                          </div>

                        </div>
                      </div>

                    </div>

                  </div>

                  <!-- 标的物状态图片 (例如：已成交) -->
                  <img v-if="biaodi_item.OBJ_STATUS == 2" style="width: 120px; height: 70px" src="@/assets/ycj.png"
                    alt="" srcset="" />
                  <img v-if="biaodi_item.OBJ_STATUS == 3" src="@/assets/ycj.png" alt="" srcset="" />
                  <!-- 状态3图片相同? -->

                  <!-- 标的结束时间 -->
                  <div v-if="biaodi_item.OBJ_END_TIME_TEXT"><span style="font-weight: 600">结束时间</span> {{
                    biaodi_item.OBJ_END_TIME_TEXT
                  }}
                  </div>

                  <!-- 报价状态和次数 -->
                  <div class="b footer_box">
                    <!-- <span style="margin-right: 30px" class="footer_text1">{{ item.QUOTED_TEXT }}</span> -->
                    <!-- 例如：领先, 出局 -->
                    <!-- <span style="margin-right: 30px" class="footer_text1">报价次数：{{ item.QUOTED_COUNT }}次</span> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- 标的物倒计时 (如果存在 QUOTED_TIME) -->
            <div
              v-if="!biaodi_item.QUOTED_TIME || (detail_data.BIDDING_START_TIME_TXT && is_status(detail_data.STATUS) == 3) && detail_data.STATUS == 4"
              class="right_tag_for">
              <div style="text-align: right;" v-if="biaodi_item.OBJ_STATUS == 1">已结束</div>
            </div>

            <div
              v-if="biaodi_item.QUOTED_TIME || (detail_data.BIDDING_START_TIME_TXT && is_status(detail_data.STATUS) == 3) && detail_data.STATUS == 4"
              class="right_tag_for">
              <div style="text-align: right;" v-if="biaodi_item.OBJ_STATUS == 1">已结束</div>
              <div style="display: flex;align-items: flex-start;flex-direction: column;">



                <!-- 使用自定义倒计时组件 -->
                <!-- IS_BAOJIA ：我是否报过价  true是   false否   -->
                <startCountdown @handle_update_="handle_update_"
                  v-if="biaodi_item.OBJ_STATUS == 0 && startCountdown_isshow" :biaodi_item="biaodi_item"
                  :detail_data="detail_data.BIDDING" :startTimestamp="handle_countdown(startCountdown_miao)"
                  :endTimestamp="detail_data.BIDDING.ROUND_DELAY">
                </startCountdown>
              </div>
            </div>

            <!-- 报价记录表格 (仅在竞价或开标阶段 STATUS == 3 或 4 显示) -->
            <!-- 注意: 模板逻辑为 is_status() == 3 || is_status() == 4, is_status()将4映射为3, 5/6映射为4. 所以实际是 STATUS=4 或 STATUS=5/6 时显示 -->
            <div v-if="is_status() == 3 || is_status() == 4" class="table_box">
              <div class="title_box">报价记录</div>
              <div class="table_container">
                <!-- 明标报价记录 -->
                <div v-if="detail_data.BIDDING.PRICE_TERMS == 1">
                  <table v-if="baojia_list?.title?.length != 0">
                    <thead>
                      <tr>
                        <th v-for="(e, i) in baojia_list.title" :key="i">{{ e }}</th>
                        <!-- 表头 -->
                      </tr>
                    </thead>
                    <tbody class="tbody_content">
                      <!-- 循环显示报价记录 -->
                      <tr v-for="(log, index) in baojia_list.logs" :key="index">
                        <td style="color: #999999">{{ log.COMPANY_NAME }}</td>
                        <!-- 幅度? -->
                        <td style="color: #999999">{{ log.DEFINITE }}</td>
                        <!-- 状态? -->
                        <!-- <td style="color: #999999">{{ log.IN_SHUI }}</td> -->
                        <!-- 含税? -->
                        <td style="color: #999999">{{ log.CREATE_TIME_TXT }}</td>
                        <!-- 时间 -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- 非明标报价记录 (文件上传) -->
                <div v-else>
                  <table v-if="baojia_list?.title?.length != 0">
                    <thead>
                      <tr>
                        <th v-for="(e, i) in baojia_list.title" :key="i">{{ e }}</th>
                        <!-- 表头 -->
                      </tr>
                    </thead>
                    <tbody class="tbody_content">
                      <!-- 循环显示报价记录 -->
                      <tr v-for="(log, index) in baojia_list.logs" :key="index">
                        <td style="color: #999999">{{ log.BJ_INFORMATION_NAME }}</td>
                        <!-- 文件名 -->
                        <td style="color: #999999">{{ log.CREATE_TIME_TXT }}</td>
                        <!-- 时间 -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- 空数据提示 (已注释掉) -->
                <!-- <div v-if="item.QUOTED_LOGS.logs.length == 0"> 暂无报价数据... </div> -->
              </div>
            </div>
          </div>
          <div>
            <div style="color: #667799;font-size: 14px;padding: 0 0 10px 10px;"
              v-if="detail_data.BIDDING.BIDDING_TYPE == 2">

              竞价时长=自由竞价x分+延时周期x分钟+延时周期x分钟/次。</br>
              1、竞价时长在自由竞价计时结束后自动进入延时周期计时，延时周期无人出价，竞价结束。</br>
              2、竞价时长在自由竞价计时结束后自动进入延时周期计时，延时周期有新的报价则按照“延时周期”重新倒计时，延时周期无人出价，竞价结束。
            </div>
            <div style="color: #667799;font-size: 14px;padding: 0 0 10px 10px;" v-else>

              竞价时长=自由竞价x分。</br>
              1、竞价时长在自由竞价计时结束后，竞价结束。
            </div>
          </div>
        </div>
        <!-- 标的物循环结束 -->
      </div>

      <!-- 主要内容区域 -->

      <div class="process-timeline">
        <!-- 步骤1 -->
        <div class="timeline-item active">
          <div class="timeline-node">
            <span class="node-number">1</span>
          </div>
          <div class="timeline-label">查看项目公告</div>
          <div class="timeline-line"></div>
        </div>

        <!-- 步骤2 -->
        <div class="timeline-item active">
          <div class="timeline-node">
            <span class="node-number">2</span>
          </div>
          <div class="timeline-label">查看竞价信息</div>
          <div class="timeline-line"></div>
        </div>

        <!-- 步骤3 -->
        <div class="timeline-item active">
          <div class="timeline-node">
            <span class="node-number">3</span>
          </div>
          <div class="timeline-label">项目报名</div>
          <div class="timeline-line"></div>
        </div>

        <!-- 步骤4 -->
        <div class="timeline-item active">
          <div class="timeline-node">
            <span class="node-number">4</span>
          </div>
          <div class="timeline-label">提交资料</div>
          <div class="timeline-line"></div>
        </div>

        <!-- 步骤5 -->
        <div class="timeline-item active">
          <div class="timeline-node">
            <span class="node-number">5</span>
          </div>
          <div class="timeline-label">参与竞价/比价</div>
          <div class="timeline-line"></div>
        </div>

        <!-- 步骤6 -->
        <div class="timeline-item active">
          <div class="timeline-node">
            <span class="node-number">6</span>
          </div>
          <div class="timeline-label">完成</div>
        </div>
      </div>

      <div v-show="true" class="header_">
        <div v-show="false" class="fjsl">
          {{ detail_data.BIDDING.TITLE }}
        </div>
        <div v-show="false" class="header_1">
          <div style="display: flex;align-items: center;">
            <span v-if="detail_data.BIDDING.BIDDING_TYPE == 2" class="text_1">
              多轮竞价
            </span>
            <span style="display: flex;align-items: center;" class="text_2">
              <div>
                {{ formatDate(detail_data.BIDDING_START_TIME_TXT) }}开始
              </div>
              <span style="margin: 0 10px;"> | </span>
              <div style="margin-top: 0" class="b">
                <span v-if="timeLeft != '竞价时间已到'" style="color: #333"> 竞价/询比价倒计时: </span>
                <span v-if="timeLeft == '竞价时间已到' || timeLeft == '竞价已结束'">
                  {{ timeLeft }}
                </span>
                <!-- 正在倒计时 -->
                <span v-else>
                  <span style="color: #999; margin: 0 3px">{{ detail_data.STATUS <= 3 ? '距开始' : '距结束' }}:</span>
                      <span class="time">{{ timeLeft.days }}</span>
                      <span class="text">天</span>
                      <span class="time">{{ timeLeft.hours }}</span>
                      <span class="text">时</span>
                      <span class="time">{{ timeLeft.minutes }}</span>
                      <span class="text">分</span>
                      <span class="time">{{ timeLeft.seconds }}</span>
                      <span class="text">秒</span>
                  </span>
              </div>
            </span>
          </div>
          <div :class="style_fun" class="right_tag">
            {{ text_fun }}
          </div>
        </div>

        <div v-if="detail_data.IS_APPLY == 1" style="display: flex;justify-content: center;" class="header_2">
          <!-- <div class="left_1">
          <div class="item_1">
            <span class="jjsc_">竞价时长：{{ calculateMinutesBetween()
            }}分钟 </span>
            <span class="jjsc_"> 项目分类：{{ detail_data.TYPE_NAME }} </span>

          </div>
          <div class="item_1">
            <span v-show="detail_data.IS_NEED == '1'" class="jjsc_"> 保证金：{{ detail_data.NEED_MONEY.MONEY
            }}元； </span>
          </div>
        </div> -->
          <div class="left_2">
            <!-- IS_APPLY 竞价是否报名制 0否 1是  -->
            <div v-if="detail_data.IS_APPLY == 1 && detail_data.IS_BAOMING == '0'" class="footer_btn">

              <!-- 立即参与按钮 (带确认) -->
              <el-popconfirm @cancel="cancel" @confirm="handle_apply(2)" title="确定参与吗？">
                <div slot="reference" class="btn btn2 center_box xiaoshou">立即参与</div>
              </el-popconfirm>

              <!-- 不参与按钮 (带确认) -->
              <el-popconfirm @cancel="cancel" @confirm="handle_apply(1)" title="确定不参与吗？">
                <div slot="reference" class="btn center_box xiaoshou">不参与</div>
              </el-popconfirm>

            </div>

            <!-- 省审核状态 -->
            <div v-if="detail_data.IS_APPLY == 1 && detail_data.IS_BAOMING != '0' && detail_data.STATUS < 4"
              class="status">
              <div v-if="detail_data.IS_BAOMING == '2'" style="background: transparent;" class="first center_box">
                已报名,待审核
              </div>
              <div v-if="detail_data.IS_BAOMING == '3'" style="background: transparent;" class="first center_box">
                报名已通过
              </div>
              <div v-if="detail_data.IS_BAOMING == '1'" style="background: transparent;"
                class="first second center_box">
                您已选择不参与</div>
              <div v-if="detail_data.IS_BAOMING == '4'" style="background: transparent;"
                class="first second center_box">
                报名未成功</div>
            </div>

          </div>

        </div>
      </div>

      <div class="header_">
        <div style="font-size: 16px;" class="fjsl">
          提交资料说明
        </div>
        <div class="header_1">
          上传资料({{ detail_data.UP_DESC }})
        </div>

        <div class="header_4">
          <div v-for="item, index in detail_data.UP_INFORMATION_ARR" :key="index"
            :class="index != 4 || index != 9 ? 'shu_xian' : ''" class="file_item">
            <span style="max-width: 70%;" class="chaochu">{{ item.FILE_NAME }}</span>
            <el-button @click="download(item.FILEPATH)" size="mini" type="primary">下载</el-button>

          </div>
        </div>

      </div>



      <div style="margin-bottom: 0;" class="header_">
        <div style="font-size: 16px;" class="fjsl">
          上传资料（不包含报价信息）
        </div>

        <div>
          <table class="custom-table">
            <tr v-for="(row, rowIndex) in chunkedData" :key="rowIndex">
              <td v-for="(item, colIndex) in row" :key="colIndex">
                {{ item.NAME || item.INFORMATION_NAME }}
                <img v-if="detail_data.AUDIT_UPLOAD == 2 || detail_data.AUDIT_UPLOAD == -1" @click="handle_dle(index)"
                  class="up_img" style="width: 20px;height: 20px;" src="../assets/close.png" alt="">
              </td>
              <!-- 补充空单元格以确保每行5列 -->
              <td v-for="n in 5 - row.length" :key="'empty-' + n"></td>
            </tr>
          </table>
        </div>

        <div v-if="detail_data.IS_UPLOAD != 0 && detail_data.AUDIT_UPLOAD != -1 && detail_data.STATUS < 4"
          style="border-radius: 30px;margin-top: 20px;" class="status">
          <div v-if="detail_data.AUDIT_UPLOAD == '0'" style="border-radius: 50px;" class="first center_box">资料待审核
          </div>
          <div v-if="detail_data.AUDIT_UPLOAD == '1'" style="border-radius: 50px;" class="first center_box">资料审核通过
          </div>
          <div v-if="detail_data.AUDIT_UPLOAD == '2'" style="border-radius: 50px;" class="first second center_box">
            审核拒绝
          </div>
        </div>

        <div style="display: flex; align-items: center;">
          <my-upload v-if="detail_data.AUDIT_UPLOAD == 2 || detail_data.AUDIT_UPLOAD == -1" :is_btn="false" :limit="8"
            :auto-upload="true" up_load="/api/user/upload" @success="handleUploadSuccess2" @error="handleUploadError" />
          <div class="ge_shi"> 支持的格式： JPG、PNG、PDF、XLS、DOC、DOCX 或 XLSX 格式! </div>
        </div>

        <div v-if="detail_data.AUDIT_UPLOAD == '2'" detail_data.APPLY.REASON
          style="display: flex;justify-content: center;align-items: center;margin-bottom: 15px;"> <img
            style="width: 14px;height: 14px;" src="@/assets/stope.png" alt=""> <span style="color: #c31424;">拒绝原因：
          </span>
          {{
            detail_data.REASON_UPLOAD }}</div>

        <div v-if="detail_data.AUDIT_UPLOAD == 2 || detail_data.AUDIT_UPLOAD == -1"
          style="display: flex; align-items: center;justify-content: center;">
          <el-button @click="upload_()" size="small" type="primary">确认提交资料</el-button>

        </div>

      </div>

      <!-- max-list 结束 -->

      <!-- 标的物说明 Dialog -->
      <el-dialog :show-close="false" title="说明" :visible.sync="dialogVisible" width="33%" center>
        <div class="dialog_content">
          {{ OBJ_DESC || '暂无说明....' }}
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 缴纳保证金 Dialog -->
      <el-dialog @close="before_close" :show-close="false" title="缴纳保证金" :visible.sync="dialogVisible1" width="36%"
        center>
        <div class="dialog_content">
          <!-- 公司名称 -->
          <div class="title_">
            {{ user_info.COMPANY_NAME }}
          </div>
          <!-- 保证金余额信息 -->
          <div class="money_box">
            <div class="item_price">
              保证金:
              <span style="color: #c31424">{{ user_info.TOTAL_MONEY }}</span>
            </div>
            <div class="item_price">
              冻结保证金:
              <span style="color: #c31424">{{ user_info.FREEZE_MONEY }}</span>
            </div>
            <div class="item_price">
              可用保证金:
              <span style="color: #c31424">{{ user_info.USABLE_MONEY }}</span>
            </div>
          </div>
          <!-- 缴纳表单 -->
          <el-form :model="price_form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <!-- 所属业务中心 -->
            <el-form-item label="所属业务中心" prop="DEPID">
              <el-select v-model="price_form.DEPID" placeholder="请选择缴纳所属部门">
                <el-option v-for="item in department_list" :key="item.ID" :label="item.TITLE" :value="item.ID">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- 缴纳时间 -->
            <el-form-item label="缴纳时间" prop="JNDJ_TIME">
              <el-date-picker v-model="price_form.JNDJ_TIME" format="yyyy-MM-dd" value-format="timestamp" type="date"
                placeholder="选择日期">
              </el-date-picker>
              <!-- 使用 value-format="timestamp" 可能更方便处理 -->
            </el-form-item>
            <!-- 缴纳金额 -->
            <el-form-item label="缴纳金额" prop="MONEY">
              <el-input type="number" v-model="price_form.MONEY"></el-input>
            </el-form-item>
            <!-- 缴纳凭证 -->
            <el-form-item label="缴纳金凭证" prop="IMAGE">
              <div style="display: flex">
                <!-- 凭证预览 -->
                <img v-if="price_form.IMAGE" style="width: 62px; height: 62px; margin-right: 20px"
                  :src="'https://dfh.beishancloud.com' + price_form.IMAGE" alt="" />
                <!-- 域名应配置化 -->
                <!-- 凭证上传组件 -->
                <my-upload style="margin: 0" :limit="1" :auto-upload="true" @change="handleFileChange"
                  @success="handleUploadSuccess1" @error="handleUploadError" />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!-- Dialog 底部按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="money_submit()">确 定</el-button>
        </span>
      </el-dialog>

      <div class="update_">
        <img @click="handle_update_9()" src="../assets/update_.png" style="width: 55px;height: 55px;" alt="">
      </div>
      <Loading :loading="loading_" color="#c31424" background="rgba(0, 0, 0, 0.3)" />

    </div>
  </div>

</template>

<script>
// 引入自定义倒计时组件
import startCountdown from '@/components/view/countdown.vue'

export default {
  // 注册组件
  components: {
    startCountdown
  },
  // 组件数据
  data() {
    return {
      baojia_list: [],
      startCountdown_miao: null,
      startCountdown_isshow: true,
      djs_: {},
      now_time: '',
      is_show_2: false,
      // 选中的标的
      biaodi_item: {},
      cli_item: 9999,
      timer_1: null,
      loading_: false,
      loading: true,
      file_index: '',
      tableData: ['项目1', '项目2', '项目3', '项目4', '项目5', '项目6', '项目7'],
      file_list: [],
      department_list: [], // 部门列表 (用于保证金缴纳)
      file_name: '', // 非明标报价上传的文件名
      // 标的物倒计时 (似乎未使用，被 startCountdown 组件替代)
      countdown1: {
        minutes: 0,
        seconds: 0,
        expired: false
      },
      timer1: null, // 标的物倒计时定时器 (似乎未使用)
      timer_2: null,
      // 项目整体倒计时 (似乎未使用，被 timeLeft 对象替代)
      // countdown: '',
      timer: null, // 项目整体倒计时定时器
      update_id: '', // 非明标报价上传文件的ID
      // 控制特定 UI 元素显示的标志 (似乎未使用或逻辑不清晰)
      is_show_input2: false,
      is_show_input1: false,
      is_show_input: false,
      is_show: false, // 控制整个组件是否显示 (等待数据加载完成)
      // 缴纳保证金表单数据
      price_form: {
        JNDJ_TIME: '', // 缴纳时间
        MONEY: '', // 缴纳金额
        IMAGE: '', // 凭证图片路径
        DEPID: '' // 所属部门ID
      },
      // 缴纳保证金表单验证规则
      rules: {
        JNDJ_TIME: [
          { required: true, message: '请选择缴纳时间', trigger: 'change' } // 触发器改为 change 更合适 DatePicker
        ],
        MONEY: [{ required: true, message: '请输入缴纳金额', trigger: 'blur' }],
        IMAGE: [
          { required: true, message: '请上传凭证', trigger: 'change' } // 触发器改为 change 可能更适合 Upload
        ],
        DEPID: [
          { required: true, message: '请选择缴纳所属业务中心', trigger: 'change' } // 触发器改为 change
        ]
      },
      user_info: {}, // 当前登录用户信息 (含保证金信息)
      OBJ_DESC: '', // 当前查看的标的物说明
      timeLeft: {}, // 项目整体倒计时对象 { days, hours, minutes, seconds, status }
      id: '', // 当前项目ID
      detail_data: {
        // 项目详情数据 (初始化结构避免 VUE 警告)
        BIDDING: {},
        NEED_MONEY: {},
        UPLOAD_DESC: {},
        APPLY: {},
        IMAGES: []
      },
      search: '', // 搜索关键词 (已注释掉)
      dialogVisible: false, // 控制标的物说明 Dialog显隐
      dialogVisible1: false, // 控制缴纳保证金 Dialog显隐
      cli: 0, // 当前选中的底部 Tab ID
      // 底部 Tab 列表
      tag_list: [
        { title: '项目介绍', id: 0 },
        // { title: '标的介绍', id: 1 }, // 已注释掉
        { title: '图片展示', id: 2 },
        { title: '提交资料说明', id: 3 }
        // { title: '成交公示', id: 4 }, // 已注释掉
      ],
      // 流程状态定义 (会根据 detail_data.IS_UPLOAD 动态调整)
      state: [],
      bidAmount: '110.110', // 报价金额 (似乎未使用，标的物报价在 biao_di_list 中)
      activeTab: '项目介绍', // 当前激活的 Tab 名称 (似乎未使用，使用 cli ID)
      biao_di_list: [] // 标的物列表数据
    }
  },
  // 计算属性
  computed: {
    handle_is_bm() {
      let is_show = Boolean
      if (this.detail_data.IS_APPLY == 1) {
        is_show = this.detail_data.IS_BAOMING == 3 ? true : false
      } else {
        is_show = true
      }
      return is_show
    },
    /**
     * @description: 根据流程步骤索引返回对应的提示文本
     * @param {number} e 流程步骤索引 (0-based)
     * @return {string} 提示文本
     */
    handle_text() {
      return function (e) {
        // 原始逻辑，根据索引判断
        let textMap = {
          0: '报名截止时间',
          1: '上传文件截止时间', // 如果 state 长度变化，此索引可能不准
          2: '竞价开始时间',
          3: '开标时间'
        }
        // 改进：根据 state 数组的实际内容判断，更健壮
        if (this.state[e]) {
          switch (this.state[e].name) {
            case '报名':
              return '报名截止时间'
            case '资料':
              return '上传文件截止时间'
            case '竞价':
              return '竞价开始时间'
            case '开标':
              return '开标时间'
            default:
              return ''
          }
        }
        return '' // 默认返回空
      }
    },
    /**
     * @description: 将后端项目状态 STATUS 映射为前端流程步骤编号 (1-based)
     *              用于判断流程图的激活状态
     * @return {function} 返回一个函数，接收原始状态值
     */
    is_status() {
      // 使用闭包返回一个可以访问 this.detail_data 的函数
      return function () {
        // !!注意: 直接用 detail_data.STATUS 会导致 computed 依赖 vue 实例 this, 推荐传入参数
        // 改为接收参数: is_status(status_code)
        // 这里保持原写法，但需注意潜在问题
        let status = this.detail_data.STATUS // 获取原始状态码
        let step = 0 // 初始化步骤编号
        // 状态映射逻辑
        if (status == 4) {
          // 竞价中 -> 映射到第 3 步 (竞价)
          step = 3
        } else if (status == 5 || status == 6) {
          // 待开标/已开标? -> 映射到第 4 步 (开标)
          step = 4
        } else if (status == 7) {
          // 已公示? -> 映射到第 5 步 (假设有公示步骤)
          step = 5
        } else {
          // 其他状态 (1:报名, 2:待审核?, 3:待竞价?) 直接使用
          step = Number(status) // 确保是数字
        }
        return step // 返回映射后的步骤编号
      }
    },
    /**
     * @description: 根据项目竞价状态返回对应的 CSS 类名，用于右上角标签样式
     * @return {string} CSS 类名
     */
    style_fun() {
      let status = this.detail_data.BIDDING?.STATUS // 安全访问
      switch (status) {
        case 0:
          return 'status_style0' // 即将开始
        case 1:
          return 'status_style1' // 竞价中
        case 4:
          return 'status_style1' // 竞价中
        default:
          return 'status_style2' // 已结束/已终止/已公示等
      }
    },
    /**
     * @description: 根据项目竞价状态返回对应的文本，用于右上角标签显示
     * @return {string} 状态文本
     */
    text_fun() {
      let statusMap = ''
      let status = this.detail_data.STATUS // 安全访问, 默认为 '已结束'
      if (status == 1) {
        statusMap = '报名中'
      } else if (status == 2) {
        statusMap = '上传文件中'
      } else if (status == 3) {
        statusMap = '待竞价'
      } else if (status == 4) {
        statusMap = '竞价中'
      } else if (status == 5) {
        statusMap = '待开标'
      } else if (status == 6) {
        statusMap = '已开标'
      }
      return statusMap // 添加默认处理
    },
    chunkedData() {
      const chunkSize = 5
      const chunks = []
      for (let i = 0; i < this.file_list.length; i += chunkSize) {
        chunks.push(this.file_list.slice(i, i + chunkSize))
      }
      return chunks
    }
  },
  // 生命周期函数：实例销毁前
  beforeDestroy() {
    // 清除项目整体倒计时定时器，防止内存泄漏
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    clearInterval(this.timer_1)
    clearInterval(this.timer_2)
    // 清除标的物倒计时定时器 (如果实际使用了)
    // if (this.timer1) {
    //   clearInterval(this.timer1);
    //   this.timer1 = null;
    // }
  },
  // 生命周期函数：实例创建完成后
  async created() {
    console.log('--createdcreatedcreatedcreatedcreatedcreatedcreatedcreatedcreated--->');
    // 从 localStorage 获取用户信息和项目ID
    this.user_info = JSON.parse(localStorage.getItem('user_info') || '{}') // 添加默认空对象
    this.id = localStorage.getItem('get_info_id')
    // 初始化数据加载
    this.get_detail() // 获取项目详情
    this.get_biao_di() // 获取标的物列表
    this.get_table_list() // 获取部门列表 (用于保证金)
    this.get_new_time()

    this.timer_1 = setInterval(() => {
      // this.get_biao_di_price() // 获取标的物列表
    }, 15000);
    this.timer_2 = setInterval(() => {
      this.get_biao_di_miao(99999) // 获取标的物列表
      // this.get_biao_di(99999) // 获取标的物列表
    }, 15000);
  },
  // 方法
  methods: {
    handle_biao_(e) {
      this.cli_item = e.ID
      console.log(e, '---eewqewqeqwewqewqweq-->');
      this.biaodi_item = e
      this.file_name = ''
      this.update_id = ''
      this.startCountdown_isshow = false
      this.$nextTick(() => {
        this.startCountdown_isshow = true
        this.get_biao_di_miao()

      })

    },
    handle_jiajia(item, number) {
      console.log(item, number, '---itemitemitemitemitem2121-->');
      let number_ = ''
      if (item.MAX_MSG > item.bj) {
        number_ = item.MAX_MSG
      } else {
        number_ = item.bj
      }
      console.log(number_, '---number_number_-->');
      let obj = item;
      let oldVal = Number(number_);
      let addVal = Number(number);
      console.log(oldVal, addVal, '---addValber_-->');

      console.log(addVal, '---addValaddValaddVal-->');
      // 精确加法（保留两位小数）
      let result = ((oldVal * 100) + (addVal * 100)) / 100;
      console.log(result, '--resultresultresultresult--->');
      // 更新原值，保留两位小数（可根据需求调整位数）
      obj.bj = Number(result.toFixed(2));

      console.log(obj, '---精确加法结果-->');
    },
    handle_update_() {
      this.startCountdown_isshow = false
      setTimeout(() => {
        this.get_biao_di() // 刷新标的列表 (获取最新报价信息)
        this.get_detail(999) // 刷新项目详情 (可能状态会更新)

      }, 500);



    },
    handle_update_9() {
      this.loading_ = true

      setTimeout(() => {
        this.get_biao_di() // 刷新标的列表 (获取最新报价信息)
        this.get_detail(999) // 刷新项目详情 (可能状态会更新)

        this.loading_ = false
      }, 500);

    },
    handle_update() {

      setTimeout(() => {
        this.get_biao_di() // 刷新标的列表 (获取最新报价信息)
        this.get_detail(999) // 刷新项目详情 (可能状态会更新)

      }, 500);

    },
    handle_index(e) {
      this.file_index = e
      console.log(e, '----->');
    },
    handle_dle(e) {
      this.file_list.splice(e, 1)
    },
    /**
     * @description: 获取部门列表 (用于保证金缴纳选择)
     */
    async get_table_list() {
      try {
        const res = await this.$http.post('/api/common/get_department_list', {})
        if (res.data.code === 200) {
          this.department_list = res.data.data
        } else {
          this.$message.error(res.data.msg || '获取部门列表失败')
        }
      } catch (error) {
        console.error('获取部门列表异常:', error)
        this.$message.error('获取部门列表失败，请稍后重试')
      }
    },

    /**
     * @description: 下载文件
     * @param {string} url 文件下载地址
     */
    download(url) {
      if (url) {
        window.location.href = url // 使用 window.location.href 进行下载
      } else {
        this.$message.warning('文件地址无效')
      }
    },

    /**
     * @description: 处理列表项点击 (似乎未使用)
     * @param {object} e 点击项的数据
     */
    handleClick(e) {
      // 这个方法在当前模板中似乎没有被调用
      // 如果是用于点击某个列表跳转到详情，逻辑可能需要调整
      console.log('handleClick triggered with:', e)
      // this.id = e.ID;
      // this.$nextTick(() => {
      //   this.get_detail(); // 传入 e 可能导致 get_detail 逻辑问题
      // });
    },

    /**
     * @description: 提交标的物报价
     * @param {object} item 当前标的物对象
     */
    async handle_chujia(item) {
      console.log(item, '----->')

      // if (this.detail_data.IS_UPLOAD == 1) {
      // item.all_number = item.bj - item.MAX_MSG
      item.all_number = Number(item.bj)
      item.all_number = Number(item.all_number);
      // } else {
      //   item.all_number = item.bj
      // }

      this.$confirm('确认报价内容,提交后无法修改', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.handle_bj(item)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    async handle_bj(item) {
      let params = {
        project_id: this.id,
        obj_id: item.ID
      }

      // 根据标的类型准备不同的报价参数
      if (this.detail_data.BIDDING.PRICE_TERMS == 1) {
        // 明标
        if (!item.bj) {
          this.$message.warning('请填写报价金额')
          return
        }
        // 注意：此处原代码有关于起拍价的校验被注释掉了，根据需求决定是否恢复
        // if (parseFloat(item.STARTING_PRICE) > parseFloat(item.bj)) {
        //   this.$message.warning('报价不能低于起拍价');
        //   return;
        // }
        params.bj = item.all_number.toFixed(2) // 报价金额
      } else {
        // 非明标 (文件报价)
        if (!this.update_id) {
          this.$message.warning('请先上传报价文件')
          return
        }
        params.bj = this.update_id // 报价文件ID
      }

      try {
        const res = await this.$http.post('/api/bidding/quoted', params)
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg || '报价成功',
            type: 'success'
          })
          // 报价成功后刷新数据
          this.get_biao_di() // 刷新标的列表 (获取最新报价信息)
          this.get_detail() // 刷新项目详情 (可能状态会更新)
          // 清空上传的文件名和ID (如果是文件报价)
          if (this.detail_data.BIDDING.PRICE_TERMS != 1) {
            this.file_name = ''
            this.update_id = ''
          }
        } else {
          this.$message.error(res.data.msg || '报价失败')
        }
      } catch (error) {
        console.error('报价请求异常:', error)
        this.$message.error('报价失败，请稍后重试')
      }
    },

    /**
     * @description: 显示标的物说明弹窗
     * @param {string} desc 标的物说明文本
     */
    handle_info(desc) {
      this.OBJ_DESC = desc
      this.dialogVisible = true
    },

    async get_biao_di_price() {
      const res = await this.$http.get('/api/project/get_obj_max', {
        params: {
          id: this.id
        }
      })
      // console.log(this.biao_di_list, '--get_biao_di_priceget_biao_di_price--->');

      // 给每个标的物添加 bj 属性用于绑定输入框，避免直接修改 props
      let res_list = res.data.data
      if (res_list.length === this.biao_di_list.length) {
        this.biao_di_list.forEach((item, index) => {
          item.MAX_MSG = res_list[index].MAX_MSG;
        });
      }

      this.$nextTick(() => {
        if (this.biaodi_item) {
          let biaodi_old = this.biao_di_list.filter(item => {
            return item.ID == this.biaodi_item.ID
          })
          this.biaodi_item = biaodi_old[0]
        }
      })

    },

    /**
    * @description: 实时刷新标的
    */
    async get_biao_di_miao(e) {
      try {
        const res = await this.$http.get('/api/project/get_obj', {
          params: {
            id: this.id
          }
        })
        if (res.data.code == 200) {
          // 给每个标的物添加 bj 属性用于绑定输入框，避免直接修改 props

          let biao_di_list = res.data.data

          // 最高价
          if (biao_di_list.length === this.biao_di_list.length) {
            this.biao_di_list.forEach((item, index) => {
              item.MAX_MSG = biao_di_list[index].MAX_MSG;
            });
          }
          this.$nextTick(() => {
            if (this.biaodi_item) {
              let biaodi_old = this.biao_di_list.filter(item => {
                return item.ID == this.biaodi_item.ID
              })
              this.biaodi_item = biaodi_old[0]
            }
          })




          console.log(biao_di_list, '--biao_di_listbiao_di_list--->');



          this.$nextTick(() => {
            if (this.biaodi_item) {
              let biaodi_old = biao_di_list.filter(item => {
                return item.ID == this.biaodi_item.ID
              })
              this.baojia_list = biaodi_old[0].QUOTED_LOGS
              console.log(biaodi_old, '----biaodi_oldbiaodi_old->');
              this.startCountdown_miao = biaodi_old[0].QUOTED_TIME
              // console.log(this.startCountdown_miao, '-biaodi_obiaodi_oldld---->');
            }
          })

          setTimeout(() => {
            this.startCountdown_isshow = true
          }, 500);


        } else {
          // this.$message.error(res.data.msg || '获取标的物列表失败')
        }
      } catch (error) {
        console.error('获取标的物列表异常:', error)
        // this.$message.error('获取标的物列表失败，请稍后重试')
      }
    },

    /**
     * @description: 获取标的物列表数据
     */
    async get_biao_di(e) {
      try {
        const res = await this.$http.get('/api/project/get_obj', {
          params: {
            id: this.id
          }
        })
        if (res.data.code == 200) {
          // 给每个标的物添加 bj 属性用于绑定输入框，避免直接修改 props

          this.biao_di_list = res.data.data.map(item => ({
            ...item,
            bj: item.QUOTED_COUNT > 0 ? item.MAX_BJ : item.STARTING_PRICE,
            all_number: 0,
          }));


          this.biao_di_list = JSON.parse(JSON.stringify(this.biao_di_list))

          this.get_biao_di_price() // 获取标的物列表
          console.log(this.biao_di_list, '--biao_di_listbiao_di_list--->');
          // this.$nextTick(() => {
          //   // 标的物倒计时逻辑似乎已由 startCountdown 组件处理
          //   // this.biao_di_countdown()
          // })

          if (this.cli_item == 9999) {
            this.cli_item = this.biao_di_list[0].ID
            this.biaodi_item = this.biao_di_list[0]
          }
          this.$nextTick(() => {
            if (this.biaodi_item) {
              let biaodi_old = this.biao_di_list.filter(item => {
                return item.ID == this.biaodi_item.ID
              })
              this.biaodi_item = biaodi_old[0]
              this.is_show_2 = true
            }
          })

          this.biaodi_item = JSON.parse(JSON.stringify(this.biaodi_item))

          this.get_biao_di_miao()

        } else {
          this.$message.error(res.data.msg || '获取标的物列表失败')
        }
      } catch (error) {
        console.error('获取标的物列表异常:', error)
        this.$message.error('获取标的物列表失败，请稍后重试')
      }
    },

    // biao_di_countdown() {
    //   // 此方法似乎未使用或被替代
    // },

    handle_countdown(e) {
      let str = ''
      if (e) {
        str = e
      } else {
        let now_ = Date.now()
        let end_time = this.detail_data.BIDDING.BIDDING_END_TIME * 1000
        // 这个是this.detail_data?.BIDDING.BIDDING_END_TIME  这个条件now_ > end_time
        // str = this.detail_data?.BIDDING.BIDDING_END_TIME
        str = now_ > end_time ? this.detail_data?.BIDDING.BIDDING_END_TIME : this.detail_data?.BIDDING_START_TIME
      }
      console.log(str, '--strstrstrstr--->');
      return str
    },

    /**
     * @description: 获取项目详细信息
     * @param {number} [flag] - 可选标志，例如 2 表示是倒计时结束后的刷新，避免重复启动倒计时
     */
    async get_detail(flag) {
      this.loading = true
      try {
        const res = await this.$http.get('/api/project/get_info', {
          params: {
            id: this.id
          }
        })

        if (res.data.code === 200) {
          this.detail_data = res.data.data
          this.file_list_name = this.detail_data.INFORMATION_INFO
          if (this.detail_data.STATUS >= 3) {
            this.cli = 3
          }

          this.file_list = this.detail_data.INFORMATION_INFO
          this.detail_data = JSON.parse(JSON.stringify(this.detail_data))

          // 更新开标状态的标题和时间
          // 使用 is_status() 计算当前逻辑步骤


          // 启动或更新倒计时 (仅当非倒计时结束触发的刷新时)
          if (flag != 999) {
            // 状态小于5才需要倒计时
            this.startCountdown()
          }

          this.loading = false
          this.is_show = true // 数据加载完成，显示组件
        } else {
          this.$message.error(res.data.msg || '获取项目详情失败')
          this.is_show = false // 加载失败也标记为 false 或 true 以显示错误信息？
        }
      } catch (error) {
        console.error('获取项目详情失败:', error)
        this.$message.error('获取项目详情失败，请稍后重试')
        this.is_show = false // 异常时也标记
      }
    },

    /**
     * @description: 处理底部 Tab 点击切换
     * @param {number} e Tab 的 ID
     */
    handleCli(e) {
      this.cli = e
    },

    // switchTab(tab) {
    //   // 此方法似乎未使用，已被 handleCli 替代
    //   this.activeTab = tab;
    // },

    /**
     * @description: 打开缴纳保证金弹窗
     */
    handle_bzj() {
      // 可以在这里先获取最新的用户保证金信息
      // await this.fetchUserBalance(); // 假设有这个方法
      this.dialogVisible1 = true
    },

    /**
     * @description: Popconfirm 取消按钮事件 (空实现)
     */
    cancel() {
      // 可以添加取消时的逻辑，例如日志记录
      console.log('用户取消了操作')
    },

    /**
     * @description: 提交参与或不参与项目
     * @param {number} status 1: 不参与, 2: 参与
     */
    async handle_apply(status) {
      try {
        const res = await this.$http.post('/api/bidding/apply', {
          status: status,
          id: this.id
        })
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg || (status === 1 ? '已标记为不参与' : '报名成功'),
            type: 'success'
          })
          this.get_detail() // 刷新项目详情以更新状态
          this.get_biao_di()

        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      } catch (error) {
        console.error('参与/不参与请求异常:', error)
        this.$message.error('操作失败，请稍后重试')
      }
    },

    /**
     * @description: 提交缴纳保证金表单
     */
    money_submit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          // 准备提交的数据
          let formData = { ...this.price_form }
          // 转换时间: 如果 JNDJ_TIME 是 Date 对象或时间戳字符串, 转为秒级时间戳
          if (formData.JNDJ_TIME) {
            // el-date-picker 如果 value-format="timestamp" 则已经是毫秒时间戳
            // 如果不是，则需要 new Date(formData.JNDJ_TIME).getTime() / 1000
            if (typeof formData.JNDJ_TIME === 'number') {
              // 假设是毫秒时间戳
              formData.JNDJ_TIME = Math.floor(formData.JNDJ_TIME / 1000)
            } else if (formData.JNDJ_TIME instanceof Date) {
              // 如果是 Date 对象
              formData.JNDJ_TIME = Math.floor(formData.JNDJ_TIME.getTime() / 1000)
            } else {
              // 尝试解析日期字符串 (可能需要更健壮的解析)
              const date = new Date(formData.JNDJ_TIME)
              if (!isNaN(date.getTime())) {
                formData.JNDJ_TIME = Math.floor(date.getTime() / 1000)
              } else {
                this.$message.error('无效的缴纳时间格式')
                return // 阻止提交
              }
            }
          }

          try {
            const res = await this.$http.post('/api/user/payment', formData)
            if (res.data.code == 200) {
              this.$message({
                message: res.data.msg || '保证金缴纳信息提交成功',
                type: 'success'
              })
              this.get_detail() // 刷新项目数据 (可能需要更新保证金状态)
              this.get_biao_di()

              // 可能还需要刷新用户信息中的保证金余额
              // await this.fetchUserInfo();
              this.dialogVisible1 = false // 关闭弹窗
              // 重置表单在 before_close 中完成
            } else {
              this.$message.error(res.data.msg || '提交失败')
              // 如果是因为时间戳转换问题导致后端报错，需要恢复 JNDJ_TIME 原始值
              // this.price_form.JNDJ_TIME = originalTimeValue;
            }
          } catch (error) {
            console.error('缴纳保证金请求异常:', error)
            this.$message.error('提交失败，请稍后重试')
            // 同上，可能需要恢复 JNDJ_TIME
          }
        } else {
          console.log('保证金表单验证失败')
          return false
        }
      })
    },

    /**
     * @description: 时间数字补零格式化 (例如: 9 -> '09')
     * @param {number} num 需要格式化的数字
     * @return {string} 格式化后的字符串
     */
    formatTime(num) {
      return num.toString().padStart(2, '0')
    },

    /**
     * @description: 将日期字符串格式化为 "MM月DD日HH:mm"
     * @param {string} dateString ISO 格式的日期字符串 (例如 "2024-07-15T10:00:00.000Z")
     * @return {string} 格式化后的字符串
     */
    formatDate(dateString) {
      if (!dateString) return ''
      try {
        const date = new Date(dateString)
        // 检查日期是否有效
        if (isNaN(date.getTime())) {
          return '无效日期'
        }
        const month = date.getMonth() + 1
        const day = date.getDate()
        const hours = date.getHours()
        const minutes = date.getMinutes()
        return `${month}月${day}日${this.formatTime(hours)}:${this.formatTime(minutes)}`
      } catch (e) {
        console.error('日期格式化错误:', e)
        return dateString // 出错时返回原始字符串
      }
    },

    /**
     * @description: 启动项目整体倒计时
     */
    startCountdown() {
      console.log('-----> 启动项目整体倒计时')
      // 先清除已有的定时器，防止重复启动
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      // 立即执行一次计算，避免延迟1秒才显示
      this.calculateTimeLeft()
      // 设置定时器，每秒更新一次
      this.timer = setInterval(() => {
        this.calculateTimeLeft()
      }, 1000)
    },
    is_time_show(e, QUOTED_TIME) {
      // IS_UPLOAD竞价填写资料 0一次提交 1多次提交  
      let str = this.detail_data.IS_UPLOAD == 0 ? this.detail_data?.PUBLISH_TIME : this.detail_data?.BIDDING_START_TIME
      if (e) {
        // str = this.detail_data?.BIDDING_START_TIME
      }
      if (QUOTED_TIME) {
        str = QUOTED_TIME // 	最后出价时间戳  
      }
      let all_time = this.detail_data.BIDDING?.BIDDING_END_TIME // 竞价结束时间
      let time_ = (Number(this.detail_data.BIDDING.ROUND_DELAY) * 60 * 1000)
      let contn_time = str + Number(this.detail_data.BIDDING.ROUND_DELAY) * 60 // 多轮 每轮延时竞价时长  
      if (all_time < contn_time) {
        return false
      } else {
        return true
      }
    },

    async get_new_time() {
      const time = await this.$http.post('/api/index/get_time')
      this.now_time = time.data.data.time
    },

    /**
     * @description: 计算项目整体剩余时间 (距开始或距结束)
     */
    async calculateTimeLeft() {
      this.get_new_time()
      //BIDDING_START_TIME 竞价开始时间
      console.log('-calculateTimeLeft---->');
      const startTime = this.detail_data?.BIDDING_START_TIME
      // 计算剩余时间（毫秒）
      const diff = startTime - this.now_time;

      // 如果时间已过，返回全0
      if (diff <= 0) {
        this.djs_ = {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: 'end'
        };

        setTimeout(() => {
          this.handle_update()
        }, 4000);

        clearInterval(this.timer)
        return
      }
      // 计算天数、小时、分钟、秒
      const days = Math.floor(diff / (60 * 60 * 24));
      const hours = Math.floor((diff % (60 * 60 * 24)) / (60 * 60));
      const minutes = Math.floor((diff % (60 * 60)) / (60));
      const seconds = Math.floor((diff % (60)));

      this.djs_ = {
        days: this.formatTime(days),
        hours: this.formatTime(hours),
        minutes: this.formatTime(minutes),
        seconds: this.formatTime(seconds)
      };


    },
    formatTime(time) {
      return time < 10 ? `0${time}` : time.toString();
    },
    /**
     * @description: 计算竞价时长 (分钟)，直接从后端数据获取
     * @return {number | string} 竞价时长或提示
     */
    calculateMinutesBetween() {
      // 直接返回后端提供的时长字段 DURATION
      return this.detail_data.BIDDING?.DURATION ?? '未知' // 安全访问并提供默认值
    },

    /**
     * @description: 文件上传组件 change 事件回调 (似乎未使用)
     * @param {object} file 当前文件信息
     * @param {array} fileList 文件列表
     */
    handleFileChange(file, fileList) {
      console.log('文件状态改变:', file, fileList)
      // 通常在 success 事件中处理上传结果
    },

    /**
     * @description: 缴纳保证金凭证上传成功回调
     * @param {object} response 服务器响应
     * @param {object} file 上传的文件信息
     * @param {array} fileList 文件列表
     */
    handleUploadSuccess1(response, file, fileList) {
      if (response.code == 200 && response.data && response.data.FILEPATH) {
        this.$message({
          message: '凭证上传成功',
          type: 'success'
        })
        this.price_form.IMAGE = response.data.FILEPATH // 更新表单中的图片路径
        // 手动触发一次表单校验，清除可能存在的 '请上传凭证' 提示
        this.$refs.ruleForm.validateField('IMAGE')
      } else {
        this.$message.error(response.msg || '凭证上传失败')
        // 清空可能已设置的IMAGE路径
        this.price_form.IMAGE = ''
      }
    },

    /**
     * @description: “提交资料说明” Tab 中的文件上传成功回调
     * @param {object} response 服务器响应
     */
    handleUploadSuccess2(response, file, fileList) {
      if (response.code == 200 && response.data && response.data.ID) {
        // this.$message({ // 成功消息可以在 upload_file 方法中提示
        //   message: '文件上传成功，正在提交...',
        //   type: 'success'
        // });
        let fileData = response.data
        this.file_list.push(fileData)
        console.log(this.file_list, '---this.file_list-->')
        // this.upload_file(fileData); // 调用提交资料的方法
      } else {
        this.$message.error(response.msg || '文件上传失败')
      }
    },
    upload_() {
      this.$confirm('该上传是项目所需资质资料，不要包含报价资料', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let id_arr = this.file_list.map(item => {
            return item.ID
          })
          if (id_arr.length == 0) {
            this.$message.warning('请先上传文件')
            return
          }
          this.upload_file(id_arr.join(','))
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // });
        })
    },

    /**
     * @description: 提交 “提交资料说明” Tab 上传的文件
     * @param {object} fileData 上传成功后返回的文件信息 (包含 ID)
     */
    async upload_file(fileData) {
      // 1. 去掉引号 2. 按逗号分割 3. 过滤空值
      const result = fileData.replace(/"/g, '').split(',').filter(Boolean);
      // 校验时间 (似乎应该是检查上传截止时间，而不是报名截止时间?)
      let uploadEndTime = this.detail_data.UPLOAD_DESC?.UP_END_TIME // 获取上传截止时间戳 (秒)
      if (uploadEndTime && this.isAfterTimestamp(uploadEndTime)) {
        this.$message.warning('上传资料时间已截止')
        return
      }
      // 检查是否已报名并通过审核 (根据实际业务需求添加)
      // if(this.detail_data.APPLY?.AUDIT_STATUS !== '1') {
      //    this.$message.warning('请先报名并通过审核');
      //    return;
      // }

      try {
        const res = await this.$http.post('/api/bidding/information', {
          information: result.join(), // 文件ID
          id: this.id // 项目ID
        })
        if (res.data.code == 200) {
          this.$message({
            message: res.data.msg || '资料提交成功',
            type: 'success'
          })
          this.get_detail() // 刷新项目详情，可能更新资料提交状态
          this.get_biao_di()

        } else {
          this.$message.error(res.data.msg || '资料提交失败')
        }
      } catch (error) {
        console.error('提交资料请求异常:', error)
        this.$message.error('资料提交失败，请稍后重试')
      }
    },

    /**
     * @description: 标的物非明标报价的文件上传成功回调
     * @param {object} response 服务器响应
     */
    handleUploadSuccess3(response, file, fileList, index) {
      if (response.code == 200 && response.data && response.data.ID) {
        this.$message({
          message: '报价文件上传成功',
          type: 'success'
        })
        this.file_name = response.data.NAME // 显示文件名
        this.file_name = JSON.parse(JSON.stringify(this.file_name))
        this.update_id = response.data.ID // 保存文件ID，用于提交报价
        console.log(this.file_name, '-this.file_name---->');
      } else {
        this.$message.error(response.msg || '报价文件上传失败')
        this.file_name = []
        this.update_id = ''
      }

    },

    /**
     * @description: 检查当前时间是否晚于指定的时间戳
     * @param {number} timestamp Unix 秒级时间戳
     * @returns {boolean} true 如果当前时间晚于时间戳, false 否则
     */
    isAfterTimestamp(timestamp) {
      if (!timestamp) return false // 如果时间戳无效，返回 false
      const targetTimeMillis = timestamp * 1000 // 转换为毫秒
      const currentTimeMillis = Date.now()
      return currentTimeMillis > targetTimeMillis
    },

    /**
     * @description: 文件上传失败回调
     * @param {Error} err 错误对象
     * @param {object} file 文件信息
     */
    handleUploadError(err, file) {
      console.error('上传失败:', err, file)
      // 尝试解析错误信息
      let errorMsg = '文件上传失败，请稍后重试'
      if (err.message) {
        try {
          const errorResponse = JSON.parse(err.message)
          if (errorResponse.msg) {
            errorMsg = errorResponse.msg
          }
        } catch (e) {
          // 如果解析失败，使用原始错误信息或通用提示
          // errorMsg = err.message || errorMsg;
        }
      }
      this.$message.error(errorMsg)
    },

    /**
     * @description: 缴纳保证金 Dialog 关闭前的回调，用于重置表单
     */
    before_close() {
      // 重置表单数据
      this.price_form = {
        JNDJ_TIME: '',
        MONEY: '',
        IMAGE: '',
        DEPID: ''
      }
      // 清除表单验证状态
      this.$refs.ruleForm.clearValidate()
      console.log('缴纳保证金弹窗关闭，表单已重置')
    },

    /**
     * @description: 处理重复报价的提示 (一口价模式下)
     */
    handle_re_baojia() {
      // 根据业务逻辑，一口价可能不允许修改报价，或者有特定规则
      // this.$message.warning('您已报价，一口价模式下通常不允许修改')
      // 或者根据具体需求决定是否允许修改：
      // if (allowEdit) { ... } else { this.$message.warning(...) }
    },

    // handle_end_time() {
    //   // 此方法似乎未使用
    // },

    /**
     * @description: 将 Unix 秒级时间戳格式化为 "YYYY-MM-DD HH:mm:ss"
     * @param {number} timestamp 秒级时间戳
     * @return {string} 格式化后的日期时间字符串
     */
    formatTimestamp(timestamp) {
      if (!timestamp) return '' // 处理无效时间戳
      try {
        const date = new Date(timestamp * 1000) // 转换为毫秒
        if (isNaN(date.getTime())) return '无效日期' // 检查转换结果

        const year = date.getFullYear()
        const month = this.formatTime(date.getMonth() + 1)
        const day = this.formatTime(date.getDate())
        const hours = this.formatTime(date.getHours())
        const minutes = this.formatTime(date.getMinutes())
        const seconds = this.formatTime(date.getSeconds())

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      } catch (e) {
        console.error('时间戳格式化错误:', e)
        return String(timestamp) // 出错时返回原始时间戳
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$container-width: 1700px;
$primary-color: #e54545;

.container {
  width: 1450px !important;
  height: 100%;
  margin: 0 auto;
  display: flex;
  // align-items: center;
  // justify-content: space-between;

  .biao_list {
    display: flex;
    flex-direction: column;
    background-color: #f8f8f8;
    padding: 10px;
    height: 100%;
    margin-right: 15px;
  }

  .biao_item {
    width: 120px;
    min-height: 120px;
    margin-bottom: 10px;
    padding: 7px;
    color: #333;
    padding-bottom: 7px;
    cursor: pointer;
  }

  .title_text {
    overflow-wrap: break-word;
    /* 兼容性写法：word-wrap: break-word; */
    white-space: normal;
  }

  .select_ {
    background-color: #c31424;
    color: #fff;
  }

  .fun_btn {
    .footer {
      padding-bottom: 20px;

      .footer_btn {
        display: flex;
        justify-content: center;

        .btn {
          width: 150px;
          height: 45px;
          font-size: 24px;
          color: #ffffff;
          background: linear-gradient(180deg, #b5b5b5 0%, #7c7c7c 100%);
        }

        .btn2 {
          margin-left: 100px;
          background: linear-gradient(180deg, #ff364e 0%, #fc8a5d 100%);
        }
      }

      .status {
        .title {
          font-size: 18px;
          color: #333333;
        }

        .first {
          width: 100%;
          background: #f1fded;
          height: 65px;
          font-size: 24px;
          color: #61b96a;
        }

        .second {
          background: #ebebeb;
          color: #666666;
        }
      }
    }

    .footer_item {
      display: flex;
      margin-bottom: 20px;

      .lable {
        min-width: 140px;
        font-size: 16px;
        color: #666666;
        // margin-right: 88px;
      }

      .value {
        .bzj {
          font-size: 16px;
          color: #333333;
          line-height: 23px;
          margin-bottom: 8px;
        }
      }

      .item_box {
        display: flex;
        flex-wrap: wrap;
      }

      .item_box:nth-child(6) .img_style {
        margin-right: 0 !important;
      }

      .footer_info {
        padding: 5px 22px;
        background-color: #f7f7f7 !important;
        border: 1px solid rgba(161, 161, 161, 0.1608);
        font-size: 12px;
        color: #999999;
      }
    }
  }
}

.search {
  width: 80%;
  position: relative;
  border: 2px solid #c31424;
  height: 48px !important;
  border-radius: 5px;
  line-height: 48px;
  margin-bottom: 30px;

  ::v-deep .el-input__inner {
    border: 0 !important;
  }

  .search_input {
    width: 100%;
    font-size: 16px;
  }

  .btn {
    position: absolute;
    right: 0.8px;
    top: 0.8px;
    width: 81px;
    height: 47px;
    background: #c31424;
    border-radius: 5px 5px 5px 5px;
    color: #fff;
  }
}

.process-flow {
  display: flex;
  align-items: center;
  justify-content: space-around;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;
}

.prosce {
  display: flex;
  align-items: center;
}

.process-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    position: relative;

    .circle_img {
      position: absolute;
      left: 0;
    }

    span {
      color: #666;
      font-size: 14px;
    }
  }

  .text {
    font-size: 14px;
    color: #666;
    text-align: center;
  }

  .footer_text {
    color: #333;
    margin-top: 10px;
  }

  .footer_time {
    padding: 2px 5px;
    background-color: #f7f7f7;
    border-radius: 3px;
    border: 1px solid #e5e2e2;
    color: #666;

    font-size: 12px;
  }

  &.active {
    .circle {
      // border-color: $primary-color;

      span {
        color: $primary-color;
      }
    }

    .text {
      color: $primary-color;
    }
  }
}

.arrow {
  width: 100px;
  height: 2px;
  background-color: #c31424;
  margin: 0 20px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    right: -2px;
    top: -4px;
    width: 0;
    height: 0;
    border-left: 8px solid #c31424;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
}

.boxlist {
  width: 100%;
  border: 1px solid #e2e4ed;
  box-sizing: border-box;

  .item_box {
    position: relative;
    display: flex;
    padding: 13px 23px;

    .START_TIME {
      position: absolute;
      right: 30px;
      top: 10px;
    }

    .swiper {
      width: 285px;
      height: 285px;
      text-align: center;
      margin-right: 30px;
    }

    .right_box {
      width: 70%;

      .title {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 100%;

        .l {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .b {
            font-size: 18px;
            margin-top: 20px;
            display: flex;

            .time {
              font-size: 26px;
              color: #333333;
            }

            .text {
              font-size: 16px;
              color: #999999;
              margin: 0 3px;
            }

            .footer_text {
              font-size: 16px;
              color: #333333;
            }

            .footer_text1 {
              font-size: 14px;
              color: #999999;
            }

            .bzj {
              background-color: #f1f1f1;
              border-radius: 3px;
              padding: 8px 8px;
            }

          }
        }

        .r {
          margin-right: 111px;
          font-size: 16px;
          color: #ffa100;
        }

      }

      .price_item {
        color: #000;
        font-size: 18px;
      }

      .baojia_ {
        font-size: 18px;
        color: #4aa43f;
        margin-top: 20px;
      }

      .info_box {
        background: #f1f6ff;
        border-radius: 5px 5px 5px 5px;
        border: 1px solid rgba(89, 130, 226, 0.149);
        color: #3d6fe5;
        font-size: 13px;
        padding: 2px 6px;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .right_tag {
      position: absolute;
      right: -1px;
      top: 0;
      width: 170px;
      height: 60px;
      border-radius: 0 0 0 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
      padding-left: 10px;
    }

    .right_tag_for {
      position: absolute;
      right: 20px;
      top: 5px;
      color: #000;
    }

    .status_style0 {
      background: linear-gradient(180deg, #44e1a0 0%, #96fed3 100%);
    }

    .status_style1 {
      background: linear-gradient(180deg, #1caffc 0%, #6be3ff 100%);
    }

    .status_style2 {
      background: #787878;
    }

    .table_box {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 380px;
      height: 202px;
      border-radius: 5px 5px 5px 5px;
      border: 1px solid rgba(89, 130, 226, 0.15);

      // background-color: #1890ff;
      .title_box {
        height: 34px;
        padding: 10px 0 0 15px;
        box-sizing: border-box;
        font-size: 12px;
        color: #333333;
        box-sizing: border-box;
        border-bottom: 1px solid #f1f1f1;
        background: linear-gradient(180deg, rgba(89, 130, 226, 0.09), rgba(89, 130, 226, 0));
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th,
      td {
        padding: 3px 0;
        text-align: center;
        font-size: 12px;
        color: #555555;
        // border: 1px solid #ccc;
      }

      thead {
        // background-color: #e0e7ff;
      }

      tbody tr:nth-child(even) {
        background-color: #f9f9f9;
      }

      .tbody_content {
        max-height: 108px;
        overflow-y: scroll;
      }
    }

    .table_box {
      width: 380px;
      height: 202px;
      /* 根据实际需求调整 */
      margin: 0 auto;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      background-color: #fff;
    }

    .title_box {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }

    .table_container {
      width: 380px;
      height: 155px;
      overflow-y: auto;
      /* 允许垂直滚动 */
      max-height: 152px;
      /* 根据实际需求调整高度 */
      position: relative;
    }

    table {
      width: 100%;
      max-width: 800px;
      border-collapse: collapse;
    }

    thead {
      position: sticky;
      /* 固定表头 */
      top: 0;
      background-color: #f5f5f5;
      z-index: 1;
    }

    th,
    td {
      padding: 12px;
      text-align: center;
      border-bottom: 1px solid #ddd;
    }

    th {
      font-weight: bold;
      color: #333;
    }

    tbody tr:hover {
      background-color: #f9f9f9;
    }

    .t {
      display: flex;
    }

    .tag {
      padding: 4px 25px;
      background-color: #9bdc19;
      color: #fff;
      font-size: 16px;
      height: fit-content;
      margin-right: 6px;
      border-radius: 3px;
    }

    .c {
      font-size: 24px;
      color: #c31424;

      .i {
        font-size: 16px;
        color: #333333;
      }
    }
  }
}

.max-list {
  width: 100%;
  margin-top: 20px;
  background: #fff;
  border-radius: 4px;
  // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  .tab-nav {
    display: flex;
    // border-bottom: 1px solid #eee;
    background: #fff;
    border-radius: 4px 4px 0 0;

    .tab-item {
      padding: 10px 30px;
      font-size: 14px;
      color: #999999;
      cursor: pointer;
      position: relative;
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f9;

      &.active {
        color: #fff;
        font-weight: bold;
        background: #b09c79 !important;

        // &:after {
        //   content: '';
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 2px;
        //   background: #c31424;
        // }
      }

      &:hover {
        background: #e8e9ec;

        // color: #333;
      }
    }
  }

  .content-area {
    padding: 1px 20px;
    border: 1px solid #e2e4ed;
    min-height: 300px;
    max-height: 450px;
    overflow-y: scroll;

    .item_box {
      display: flex;
      flex-wrap: wrap;
    }

    .item_box:nth-child(6) .img_style {
      margin-right: 0 !important;
    }

    .file-list {
      .file-item {
        padding: 10px 0;
        color: #666;
        font-size: 14px;

        &:hover {
          color: #c31424;
          cursor: pointer;
        }
      }
    }

    .attachment {
      margin-top: 20px;
      display: flex;
      align-items: center;

      .attach-title {
        color: #666;
        margin-right: 10px;
      }

      .download-link {
        color: #1890ff;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .deadline {
      margin-top: 15px;
      color: #999;
      font-size: 14px;
    }

    .footer_item {
      display: flex;
      margin-bottom: 20px;

      .lable {
        min-width: 140px;
        font-size: 16px;
        color: #666666;
        // margin-right: 88px;
      }

      .value {
        .bzj {
          font-size: 16px;
          color: #333333;
          line-height: 23px;
          margin-bottom: 8px;
        }
      }

      .item_box {
        display: flex;
        flex-wrap: wrap;
      }

      .item_box:nth-child(6) .img_style {
        margin-right: 0 !important;
      }

      .footer_info {
        padding: 5px 22px;
        background-color: #f7f7f7 !important;
        border: 1px solid rgba(161, 161, 161, 0.1608);
        font-size: 12px;
        color: #999999;
      }
    }
  }
}

.status-tag {
  border-radius: 1px;
  font-size: 12px;
  color: #fff;
  height: 24px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  margin: 5px 5px 0 5px;
  width: 55px;

  &.published {
    background: #8e44ad;
  }

  &.bidding {
    background: #3498db;
  }

  &.upcoming {
    background: #f1c40f;
  }

  &.ended {
    background: #2ecc71;
  }
}

.dialog_content {
  .title_ {
    font-size: 16px;
    text-align: center;
  }

  .money_box {
    display: flex;
    justify-content: space-around;
    margin: 30px 0;

    .item_price {
      display: flex;
      align-items: center;
      font-size: 15px;
    }
  }
}

.buttom_boredr {
  border-bottom: 1px solid #eaeaea;
  margin: 0 20px;
  padding: 20px 0 !important;
}

.file_name {
  margin-left: 20px;
  margin-bottom: 5px;
  font-size: 14px;
  text-decoration-line: underline;
  color: rgb(2, 86, 255);
}

.upload1 {
  .upload1_c {
    position: relative;

    .up_img {
      position: absolute;
      right: -11px;
      top: -8px;
      cursor: pointer;
    }
  }
}

.header_ {
  width: 100%;
  margin-bottom: 10px;

  .fjsl {
    font-weight: 600;
    font-size: 24px;
  }

  .header_1 {
    display: flex;
    justify-content: space-between;
    padding: 12px 8px;
    align-items: center;
    background-color: #fafafa;
    border-bottom: 2px solid #f4f4f4;
    box-sizing: border-box;
    position: relative;

    .text_1 {
      font-size: 18px;
      margin-right: 15px;
    }

    .text_2 {
      font-size: 13px;
      color: #6e6e6e;
    }
  }

  .header_2 {
    padding: 5px 30px;
    padding-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .item_1 {
      margin-bottom: 10px;
      font-size: 16px;

      .jjsc_ {
        position: relative;
        margin-right: 30px;

        &::after {
          position: absolute;
          content: "";
          left: -10px;
          top: 50%;
          background-color: #333;
          width: 5px;
          height: 5px;
          margin-top: -2.5px;
          border-radius: 50%;
        }
      }
    }

    .left_2 {
      .footer_btn {
        display: flex;
        justify-content: center;

        .btn {
          width: 150px;
          height: 45px;
          font-size: 24px;
          color: #ffffff;
          margin-left: 50px;

          background: linear-gradient(180deg, #b5b5b5 0%, #7c7c7c 100%);
        }

        .btn2 {
          background: linear-gradient(180deg, #ff364e 0%, #fc8a5d 100%);
        }
      }
    }
  }

  .header_4 {
    border: 1px solid #efefef;
    display: flex;
    flex-wrap: wrap;
    padding: 7px 0;

    .file_item {
      width: 19.5%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;

      .xz {
        color: #c31424;
        cursor: pointer;
      }
    }

    .shu_xian {
      border-right: 1px solid #f0f0f0;
    }
  }

  .header_5 {
    border: 1px solid #e5e5e5;
    display: flex;
    flex-wrap: wrap;
    background-color: #fafafa;

    .file_item {
      width: 19.5%;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #e5e5e5;

      .xz {
        color: #c31424;
        cursor: pointer;

      }
    }

  }

  .ge_shi {
    font-size: 14px;
    color: #666;
    margin-left: 40px;
  }
}

.custom-table {
  border-collapse: collapse;
  width: 100%;
  background-color: #fafafa;
}

.custom-table td {
  border: 1px solid #e5e5e5;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
  color: #538cfd;
  text-decoration: underline;
  min-width: 60px;
  width: 19.5%;
  position: relative;

  .up_img {
    position: absolute;
    right: 3px;
    top: 50%;
    cursor: pointer;
    margin-top: -7.5px;
  }

  /* 可选：设置最小宽度 */
}

.status {
  .title {
    font-size: 18px;
    color: #333333;
  }

  .first {
    width: 100%;
    background: #f1fded;
    height: 65px;
    font-size: 24px;
    color: #61b96a;
  }

  .second {
    background: #ebebeb;
    color: #666666;
  }
}

.chaochu {
  white-space: nowrap;
  /* 禁止换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 显示省略号 */
  font-size: 14px;
  margin-right: 5px;
}

.jjz {}

.right_tag {
  position: absolute;
  right: -1px;
  top: 0;
  width: 130px;
  height: 50px;
  border-radius: 0 0 0 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  padding-left: 10px;
}

.status_style0 {
  background: linear-gradient(180deg, #44e1a0 0%, #96fed3 100%);
}

.status_style1 {
  background: linear-gradient(180deg, #1caffc 0%, #6be3ff 100%);
}

.status_style2 {
  background: #787878;
}

.bdw_detail {
  .bdw_text {
    font-size: 18px;
    box-sizing: border-box;
    display: inline-block;
    border-bottom: 0;
    border-radius: 5px 5px 0 0;
    width: 100%;

  }

  width: 100%;

  .status_9 {
    width: 100%;
    height: 85px;
    border-left: 4px solid #c31424;
    box-sizing: border-box;
    background-color: #f5f5f5;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .daijingjia {
      font-weight: 600;
      font-size: 20px;
    }

    .jjfs {
      display: flex;
      align-items: center;

      .jjfs_item {
        font-size: 14px;
        color: #b5bdcb;
        margin-right: 20px;

        &::after {
          position: absolute;
          content: "";
          left: -10px;
          top: 50%;
          background-color: #333;
          width: 5px;
          height: 5px;
          margin-top: -2.5px;
          border-radius: 50%;
        }
      }
    }
  }

}

.update_ {
  position: fixed;
  right: 30px;
  top: 80px;
  cursor: pointer;

}

.jiajia {
  display: flex;
  padding-left: 74px;
  justify-content: space-between;
  margin-top: 10px;

  .item_jiajia {
    padding: 5px 18px;
    border: 1px solid #c31424;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>

<style scoped>
.process-timeline {
  display: flex;
  align-items: center;
  width: 1100px;
  padding: 20px 0;
}

.timeline-item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  position: relative;
}

.timeline-node {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  position: relative;
  z-index: 2;
}

.timeline-item.active .timeline-node {
  background: #50a744;
  /* 绿色节点 */
}

.node-number {
  color: white;
  font-weight: bold;
  font-size: 14px;
}

.timeline-label {
  font-size: 14px;
  color: #6b7280;
  white-space: nowrap;
  margin-right: 24px;
}

.timeline-item.active .timeline-label {
  color: #50a744;
  /* 绿色文字 */
  font-weight: 500;
}

.timeline-line {
  width: 100px;
  height: 2px;
  background: repeating-linear-gradient(90deg,
      #e5e7eb,
      #e5e7eb 6px,
      transparent 6px,
      transparent 12px);
  flex-shrink: 0;
}

.timeline-item.active .timeline-line {
  background: repeating-linear-gradient(90deg,
      #50a744,
      /* 绿色虚线 */
      #50a744 6px,
      transparent 6px,
      transparent 12px);
}

/* 移除最后一个元素的连接线 */
.timeline-item:last-child .timeline-line {
  display: none;
}
</style>
